import { Button } from "reactstrap";

import styles from "./Links.module.css";
import { Link } from "./Links.style";

const LinkPreview = ({
  name,
  bgColor,
  fontColor,
  borderStyle,
  hoverBgColor,
  hoverFontColor,
  isEditing,
  deleteLink,
  currentLinkId,
}) => {
  return (
    <div className={styles.link_preview} data-testid="link-preview">
      <Link
        hoverColor={hoverBgColor}
        linkBgColor={bgColor}
        fontColor={fontColor}
        borderStyle={borderStyle}
        hoverFontColor={hoverFontColor}
      >
        <div className={styles.link}>
          <h2>{name}</h2>
        </div>
      </Link>
      {isEditing && (
        <Button
          id={currentLinkId}
          onClick={deleteLink}
          className="mt-3"
          color="danger"
        >
          Remover
        </Button>
      )}
    </div>
  );
};

export default LinkPreview;
